<template>
    <transition-group
        :css="false"
        @enter="enter"
        @afterEnter="afterEnter"
        @leave="leave"
        class="tag-wrapper"
    >
      <div
        v-for="(livingOption, index) in livingOptions"
        :key="livingOption._id"
        :data-index="index"
        
      >
        <tag-basic
          v-for="(marker, markerIndex) in livingOption.markers || []"
          style="opacity: 1"
          color="white"
          class="tag"
          type="basic"
          tailPosition="none"
          v-bind="marker"
          :key="`${livingOption._id}_tag_${markerIndex}`"
          :label="livingOption.displayName"
          :pos="{ x: marker.x, y: marker.y }"
          @click.native="navigateToSubsection(livingOption)"
        />
        <template v-if="!livingOption.isVisuallyHidden">
          <polygon-shape
            v-for="(polygon, polygonIndex) in livingOption.polygons || []"
            :key="polygon._id || `${livingOption._id}_polygon_${polygonIndex}`"
            :polygon="polygon"
            @click.native="navigateToSubsection(livingOption)"
          />
        </template>
      </div>
    </transition-group>
</template>
<script>
import PolygonShape from '@/components/PolygonShape'
import TagBasic from '@/components/TagBasic'
import { mapGetters } from 'vuex'
import { bus } from '../main'

export default {
  components: { PolygonShape, TagBasic },

  props: ['living-options'],

  computed: {
    ...mapGetters({
      activeCategory: 'activeCategory',
      activeSubsection: 'property/activeSubsection',
      activeLivingOption: 'property/activeLivingOption',
      livingOptionsLand: 'property/livingOptionsLand',
      language: 'language'
    }),

    activeLivingOptionId () {
      return this.$route.params.livingOptionId
    },
    
    categoryId () {
      return this.$route.params.categoryId
    },

    pathway () {
      return this.$route.params.pathway
    }
  },

  methods: {
    navigateToSubsection (subsection) {
      if (this.activeSubsection) {
         this.$router.push(`/${this.activeCategory}/live/${this.pathway}/${this.activeLivingOption._id}/subsection/${subsection._id}?parentSubsectionId=${subsection.parent.id}`)
      } else {
        this.$router.push(`/${this.activeCategory}/live/${this.pathway}/${this.activeLivingOption._id}/subsection/${subsection._id}`)
      }
    },
    
    setActiveSlideId (id) {
      const livingOptions = this.livingOptions
      const selectedLivingOption = livingOptions.filter(lo => lo._id === id)[0]
      this.$router.push(`/category/${this.categoryId}/live/${this.pathway}/${selectedLivingOption._id}`)
    },

    enter (el, done) {
      const tagType = el.getAttribute('data-type')

      this.animationSpeed = 100

      if (tagType === 'basic') {
        this.animationSpeed = 50
      }

      setTimeout(() => {
        el.classList.add('enter')
        done()
      }, (parseInt(this.delayIndex++) + 1) * this.animationSpeed)
    },

    afterEnter (el) {
      if (parseInt(el.dataset.index) + 1 === this.livingOptions.length) {
        bus.$emit('finishedAnimation', 'SubsectionTags')
        this.delayIndex = 0
      }
    },

    leave (el) {
      el.classList.add('leave')
      el.classList.remove('enter')
    },
  }
}
</script>
<style lang="scss" scoped>

</style>
